export default __webpack_public_path__ + "static/media/mp-03.de145df8.jpg";